module.exports = __webpack_public_path__ + "img/lotery-rewards-5.d4451ab6.jpg";